export default __webpack_public_path__ + "static/media/Balthus's Buckskin Chaps.d7d91a8e.jpg";